// Even box heights 
$(window).load(function() {
  $('.unevenHeights').setAllToMaxHeight();
});
// Cloudzoom on product.liquid
$(document).ready(function () {
	initCloudZoom();
    initColorPicker();
    initBuyButton();
    updateBag();
    bindClickEvent();
});

function initCloudZoom(){
    $('.cloud-zoom, .cloud-zoom-gallery').CloudZoom();
}

function initColorPicker(){
    $('ul#color-picker').each(function()
    {
	   var select=$(document.createElement('select')).insertBefore($(this).hide()).attr('id','color-picker').before('<label for="color-picker">Color</label>');
	   $('>li a', this).each(function()
	   { 
	 	option=$(document.createElement('option')).appendTo(select).val(this.href).html($(this).html());
	   });
	   select.change(function(){
	    //alert('url = ' + this.value );
	    window.location.href = this.value;
	  })
	});
	$('label:first').before('<hr>');
}
function initBuyButton(){
  if ($('#product-select').size() > 0){
    $('#addtobag').attr('disabled','disabled').addClass('disabled').val('SELECT A SIZE');
  	$('#product-select').change(function(){
  		if($('option:selected',this).val() != ''){
    		$('#addtobag').removeAttr('disabled').removeClass('disabled').val('ADD TO BAG');
  		} else {
  			$('#addtobag').attr('disabled','disabled').addClass('disabled').val('SELECT A SIZE');
  		}
  	});
  }
}

function bindClickEvent(){
 $('#addtobag').click(function(){
   ajaxAddItem();
  });   
}

function ajaxAddItem(){
    var itemId = $('#product-select').val();
    if(itemId == null || typeof(itemId) == 'undefined'){
       itemId = $("input[name='id'][type='hidden']").val();
    }
    var quantity = $('#quantity').val();
	Shopify.addItem(itemId,quantity);
}

var updateBag = function(){
    Shopify.getCart();
}

function showMessage(msg,isError){
	if($('#cart-response').length > 0){
        var responseContainer = $('#cart-response');
		responseContainer.show('fast');
		responseContainer.html(msg);
        
        //Add/Remove custom classes to response container.
        if(isError){
            responseContainer.addClass('error');
            responseContainer.removeClass('yay');
        }else{
            responseContainer.addClass('yay');
            responseContainer.removeClass('error');
        }
        setTimeout(function(){responseContainer.hide('slow')},3000);
	}else{
		alert(msg);
	}
}

function updateMyBagLink(numberOfItems){
    if($('#cart_top_link .cart-total-items').length >0){
      $('#cart_top_link .cart-total-items .count').text(numberOfItems);
    }else{
        var html = 'My Bag(<span class="cart-total-items"><span class="count">'+numberOfItems+'</span></span>)';
        $('#cart_top_link').html(html);
    }
}

//overides
Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  showMessage(data.description,true);
};

Shopify.fullMessagesFromErrors = function(errors) {
  var fullMessages = [];
  jQuery.each(errors, function(attribute, messages) {
    jQuery.each(messages, function(index, message) {
      fullMessages.push(attribute + ' ' + message);
    });
  });
  return fullMessages;
}

Shopify.onCartUpdate = function(cart) {
  if(cart.item_count > 0){
    updateMyBagLink(cart.item_count);
  }
};  

Shopify.onCartShippingRatesUpdate = function(rates, shipping_address) {
  var readable_address = '';
  if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
  if (shipping_address.province) readable_address += shipping_address.province + ', ';
  readable_address += shipping_address.country
  showMessage('There are ' + rates.length + ' shipping rates available for ' + readable_address +', starting at '+ Shopify.formatMoney(rates[0].price) +'.',false);
};  

Shopify.onItemAdded = function(line_item) {
  showMessage(line_item.title + ' was added to your <a class="mybag-link" href="http://fancy-french-cologne.myshopify.com/cart">shopping bag</a>.',false);
  updateBag();
};

Shopify.onProduct = function(product) {
 showMessage('Received everything we ever wanted to know about ' + product.title,false);
};

